import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import {
  Alert,
  Button,
  Checkbox,
  Form,
  Input,
  Popover,
  Typography,
  message,
} from 'antd';
import { SIGN_IN_TEXT } from 'constants/alerts';
import { Link } from 'react-router-dom';
import { LoginFormWrapper } from './style';

function LoginForm({ loading, error, onSubmit }) {
  const [form] = Form.useForm();
  const checked = Form.useWatch('checked', form);

  const onSubmitWithCaptcha = async (value) => {
    try {
      onSubmit(value);
    } catch (err) {
      message.error('Что-то пошло не так. Попробуйте еще раз', 2);
    }
  };

  return (
    <LoginFormWrapper>
      <Form
        form={form}
        onFinish={onSubmitWithCaptcha}
        layout="horizontal"
        requiredMark={false}
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={{ checked: true }}
      >
        <h4>Вход в систему</h4>

        <div className="login-form">
          <div className="login-form__inputs">
            <Form.Item
              name="username"
              label="Email"
              rules={[
                {
                  required: true,
                  message: 'Введите email',
                },
                {
                  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'Некорректный адрес почты',
                },
              ]}
            >
              <Input placeholder="email" />
            </Form.Item>

            <Form.Item
              name="password"
              label="Пароль"
              rules={[
                {
                  required: true,
                  message: 'Введите пароль',
                },
                {
                  min: 8,
                  message: 'Минимум 8 символов',
                },
              ]}
            >
              <Input.Password
                placeholder="password"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 5,
              }}
              name="checked"
              valuePropName="checked"
            >
              <Checkbox>
                Я соглашаюсь с&nbsp;
                <Popover
                  title="Пользовательское соглашение"
                  content={SIGN_IN_TEXT}
                  trigger="click"
                  overlayStyle={{ width: '360px', zIndex: 100000 }}
                >
                  <Typography.Link>
                    пользовательским соглашением
                  </Typography.Link>
                </Popover>
              </Checkbox>
            </Form.Item>

            {error && (
              <div className="login-form__error">
                <Alert message={error} type="error" showIcon />
              </div>
            )}

            <Form.Item
              wrapperCol={{
                offset: 5,
              }}
            >
              <Button
                disabled={loading | !checked}
                type="primary"
                loading={loading}
                htmlType="submit"
              >
                Войти
              </Button>
              <Link style={{ marginLeft: '20px' }} to="/recovery">
                Забыли пароль?
              </Link>
            </Form.Item>
          </div>
        </div>
      </Form>
    </LoginFormWrapper>
  );
}

export { LoginForm };
